import { Alert, Button, Group, Modal, Stack, Text } from "@mantine/core";

import { IconAlertCircle } from "@tabler/icons-react";
import { Patient } from "types/patientTypes";
import { displayPatientName } from "@utils/CommonUtil";
import { useTranslation } from "react-i18next";

interface ConfirmChangePatientModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentPatient: Patient | null;
  selectedPatient: Patient | null;
  loading: boolean;
  error?: string | null;
}

export default function ConfirmChangePatientModal({
  opened,
  onClose,
  onConfirm,
  currentPatient,
  selectedPatient,
  loading,
  error,
}: ConfirmChangePatientModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("ResultList.confirmChangePatientTitle", "Confirm Patient Change")}
      centered
      lockScroll={false}
    >
      <Stack gap="md">
        <Text>
          {t("ResultList.confirmChangePatientMessage", {
            currentPatient: currentPatient ? displayPatientName(currentPatient.name) : "—",
            selectedPatient: selectedPatient ? displayPatientName(selectedPatient.name) : "—",
            defaultValue:
              "Do you confirm your request to change the Patient for this test from {{currentPatient}} to {{selectedPatient}}?",
          })}
        </Text>

        {error && (
          <Alert color="red" icon={<IconAlertCircle size={16} />}>
            {error}
          </Alert>
        )}

        <Group justify="flex-end" mt="sm">
          <Button variant="outline" onClick={onClose} disabled={loading}>
            {t("cancel")}
          </Button>
          <Button onClick={onConfirm} loading={loading}>
            {t("confirm")}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
